import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = ["search", "map", "location", "name", "address"]

    connect() {
        try {
            this.map_location = JSON.parse(this.locationTarget.value);
        } catch( e ) {
            this.log("Error reading map_location ", this.locationTarget.value );
            this.searchTarget.value=this.locationTarget.value;
            // this.locationTarget.value="";
        }

        if (typeof (google) != "undefined"){
            this.initializeMap()
        } else {
            this.log("google maps api is not yet loaded.")
        }
    }

    initializeMap() {
        this.log('initializeMap')
        this.map()
        this.marker()
        this.autocomplete()
    }

    map() {
        if(this._map == undefined) {
            this._map = new google.maps.Map(this.mapTarget, {
                center: new google.maps.LatLng(
                    53,
                    9
                ),
                zoom: 4
            });
            this._map.addListener("click", this.mapClicked.bind(this));
        }
        return this._map
    }

    marker() {
        if (this._marker == undefined) {
            this._marker = new google.maps.Marker({
                map: this.map(),
                draggable: false,
                anchorPoint: new google.maps.Point(0,0)
            })

            if( this.map_location )
            {
                let mapLocation = {
                    lat: this.map_location.lat,
                    lng: this.map_location.lng
                }
                this._marker.setPosition(mapLocation)
                this.map().setCenter(mapLocation)
                this.map().setZoom(16)

                this.nameTarget.innerText = this.map_location.name;
                this.addressTarget.innerText= this.map_location.address;

            } else {

            }
            this._marker.setVisible(true)
        }
        return this._marker
    }

    autocomplete() {
        if (this._autocomplete == undefined) {
            this._autocomplete = new google.maps.places.Autocomplete(this.searchTarget)
            this._autocomplete.bindTo('bounds', this.map())
            this._autocomplete.setFields(['formatted_address', 'geometry', 'icon', 'name','place_id'])
            this._autocomplete.addListener('place_changed', this.placeChanged.bind(this))
        }
        return this._autocomplete
    }

    mapClicked( ev ) {
        this.log("mapClicked", [ev]);
        if( ev.placeId ) {
            const service = new google.maps.places.PlacesService(this._map);
            service.getDetails({placeId: ev.placeId, fields: ['formatted_address', 'geometry', 'icon', 'name', 'place_id']}, (place,status) => {
                this.log("place details", [place,status]);
                this.updatePlaceMarker( place );
            });
        }
        //     const service = new google.maps.places.PlacesService(this._map);
        //     service.getDetails({placeId: ev.placeId}, (place,status) => {
        //         console.log(place,status);
        //     });
        // const geocoder = new google.maps.Geocoder();
        // geocoder.geocode({ placeId: ev.placeId })
        //     .then((response)  => {
        //        console.log(response)
        //     });
        //     }
        // });
    }

    placeChanged( ev ) {
        this.log("placeChanged", [ev])
        let place = this.autocomplete().getPlace()

        this.log("place", [place])
        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        this.updatePlaceMarker( place );
    }

    updatePlaceMarker( place ) {
        this.log("updatePlaceMarker", [place])

        this.map().fitBounds(place.geometry.viewport)
        this.map().setCenter(place.geometry.location)
        this.marker().setPosition(place.geometry.location)
        this.marker().setVisible(true)

        this.locationTarget.value=JSON.stringify({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            place_id: place.place_id,
            name: place.name,
            address: place.formatted_address
        });

        this.nameTarget.innerText = place.name;
        this.addressTarget.innerText= place.formatted_address;
        this.searchTarget.value = "";
    }

    preventSubmit(e) {
        if (e.key == "Enter") { e.preventDefault() }
    }
}
